// extracted by mini-css-extract-plugin
module.exports = {"dj-news":"news_dj-news__q1xT6","dj-news-content":"news_dj-news-content__3zaim","enterpriseNews-swiper":"news_enterpriseNews-swiper__1oAbL"};